import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'

export const ReOrderServicesButton = styled(Button, {
  name: 'ReOrderServicesButton',
  slot: 'Root',
  skipSx: true,
})`
  font-family: 'Source Sans Pro';
  font-size: 15px;
  color: #19305a;
`
